export const USER_ROLE_VALIDATION = {
    name: {
        required: 'Nama wajib diisi',
    },
}
